export const stringToSlug = (text: string) =>
	text
		.toLowerCase()
		.replace(/[^\w ]+/g, "")
		.replace(/ +/g, "");

export const replaceAll = (str: string, searchStr: string, replaceStr: string) =>
	str.replace(new RegExp(searchStr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), replaceStr);

export const formatPhone = (val: string) => val?.replace(/^0+/, "");

export const formatZip = (zipcode: string) => `${zipcode.slice(0, 3)} ${zipcode.slice(3)}`;

export const trim = (val: string) => val.trim();

export const extractNumbers = (str: string) => str.replace(/[^\d]/g, "");

export const humanReadableIBAN = (str: string) =>
	str
		.replace(/\s/g, "")
		.toUpperCase()
		.match(/.{1,4}/g)
		?.join(" ") || " ";

export const formatSniCode = (code: string) => `${code.substring(0, 2)}.${code.substring(2, 5)}`;
